import React, { useState } from "react";
import {
  BackButtonContainer,
  BurgerButtonContainer,
  CloseContainer,
  Container,
  IconContainer,
  MenuContainer,
  MenuText,
  TopContainer,
} from "./style";
import { FaArrowLeft } from "@react-icons/all-files/fa/FaArrowLeft";
import { FaTimes } from "@react-icons/all-files/fa/FaTimes";
import { GiHamburgerMenu } from "@react-icons/all-files/gi/GiHamburgerMenu";
import { theme } from "nectar-ui";
import { useHistory } from "react-router-dom";
import { AstreaIcon } from "@components/svgs";
import { TenantLogoLoader } from "@components/TenantLogoLoader";
import { MenuItems } from "../MenuItems";

const TopNav = () => {
  const [isOpen, setIsOpen] = useState(false);
  const history = useHistory();
  const handleBackButton = () => {
    history.goBack();
  };

  const toggleMenu = () => {
    setIsOpen((current) => !current);
  };

  return (
    <Container>
      <BackButtonContainer onClick={handleBackButton}>
        <FaArrowLeft size={16} color={theme.standard.colors.gray500} />
      </BackButtonContainer>
      <IconContainer>
        <TenantLogoLoader height={60} clickable noShadow />
      </IconContainer>
      <IconContainer>
        <AstreaIcon />
      </IconContainer>
      <BurgerButtonContainer onClick={toggleMenu} role="button">
        <GiHamburgerMenu size={16} color={theme.standard.colors.gray500} />
        <MenuText noMargin color="gray">
          MENU
        </MenuText>
      </BurgerButtonContainer>
      <MenuContainer isOpen={isOpen}>
        <TopContainer>
          <CloseContainer role="button" onClick={toggleMenu}>
            <FaTimes size={14} color={theme.standard.colors.gray500} />
            <MenuText color="gray" noMargin>
              FECHAR
            </MenuText>
          </CloseContainer>
        </TopContainer>
        <MenuItems toggleMenu={toggleMenu} />
      </MenuContainer>
    </Container>
  );
};

export default TopNav;
